<template>
    <div class="sealList">
        <div class="seal_title">
            <div class="title">印章管理</div>
            <p style="color: red;">注：请点击ukey进行购买</p>
        </div>

        <div class="seal_message">
            <div class="for" v-for="(item,index) in sealList" :key="index">
                <el-dialog title="修改印章密码" :close-on-click-modal = "false"  :visible.sync="dialogFormVisible"style="width:50%;margin:0 auto">
                    <el-form :model="form" status-icon :rules="rules" ref="form" >
                        <el-form-item label="原始密码" prop="password" :label-width="formLabelWidth">
                        <el-input type="password" v-model="form.password"  autocomplete="off"></el-input>
                        </el-form-item>

                        <el-form-item label="新密码" prop="newPassword" :label-width="formLabelWidth">
                        <el-input type="password" v-model="form.newPassword"  autocomplete="off"></el-input>
                        </el-form-item>

                        <el-form-item label="确认新密码" prop="againPassword" :label-width="formLabelWidth">
                        <el-input type="password" v-model="form.againPassword"  autocomplete="off"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="handlUpdate()">确 定</el-button>
                    </div>
                </el-dialog>
                <div style="border: solid 1px #aaaaaa;">
                    <div class="img">
                        <img :src="'data:image/png;base64,'+ item.stampTemplateBase64"/>
                    </div>
                    <div  v-if="item.state==='2'" class="zhang-btn" >
                        <div class="btn1" style="width: 100%;" @click="toApplySeal(item)">
                            重新提交审核
                        </div>
                      <div class="btn2" @click="handlDele(item)">
                        删除
                      </div>
                    </div>
                    <div v-else-if="item.state==='1'" class="zhang-btn">                 
                        <div  class="btn1"  @click="toUkeyOrder(item)" style="width: 50%"
                            v-show="item.state === '1' && item.isUkey === 1 && item.paySuccess !== 1" >
                            ukey下单
                        </div>

                        <div class="btn1" @click="handlJump(item)" v-if="item.isUkey===1" style="width: 50%">
                            续期
                        </div>
                        <div class="btn1" @click="handlJump(item)" v-else >
                            续期
                        </div>
                        <div class="btn2" @click="handlDele(item)" v-if="item.isUkey!==1">
                            删除
                        </div>
                        <div class="btn4" @click="openUpdate(index)" style="width: 50%">
                            修改密码
                        </div>

                    </div>
                    <div v-else class="zhang-btn">
                        <div class="btn1" style="width: 100%;">
                          审核中
                        </div>
                    </div>
                    <div>
                        <div class="ukey" v-show="item.isUkey===1"  
                             style=" cursor: pointer; z-index: 90;">
                            ukey
                        </div>
                    </div>
                </div>
                <!--        -->
                <div class="zheG" v-show="item.state === '1' && item.isUkey === 1 && item.paySuccess !== 1">
                    ukey待支付
                </div>
                <div class="sinType">

                </div>
                <div class="text">{{ item.signType == 1 ? '个人' : '企业' }}</div>
                <div class="endDay" style="font-weight: bold">{{item.name}}</div>
                <div class="endDay">剩余天数：{{ item.expireDay }}天</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入旧密码'));
                } else{
                     callback();
                }
              
            };
            var validatePass3 = (rule, value, callback) => {
                if (value === '') {
                 callback(new Error('请输入新密码'));
                } else {
                    if (this.form.againPassword !== '') {
                        this.$refs.form[0].validateField('againPassword');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入新密码'));
                } else if (value !== this.form.newPassword) {
                    callback(new Error('两次输入新密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                updateIndex:0,
                sealDialogVisible: false,
                dialogFormVisible:false,
                options: [{
                    value: '选项1',
                    label: '个人印章'
                }, {
                    value: '选项2',
                    label: '企业印章'
                }],
                value: '',
                sealList: [],
                form:{
                    password:'',
                    newPassword:'',
                    againPassword:'',
                },     
                rules: {
                password: [
                    { validator: validatePass, trigger: 'blur' },
                ],
                newPassword: [
                    { validator: validatePass3, trigger: 'blur' },
                ],
                againPassword: [
                    { validator: validatePass2, trigger: 'blur' },
                ],
                 }
            };
        
        },

        mounted() {
            let param = new FormData();
            param.append('token', this.$global.token);
            this.getData(param);
        },
        methods: {
            toApplySeal(item) {
                
                if( item.signType == 1 ){

                    this.$router.push({
                        name: 'addOnePerSeal',
                        params: {
                            id: item.id,
                        }
                    });

                }else if( item.signType == 2 ){

                    this.$router.push({
                        name: 'entSeal',
                        params: {
                            id: item.id,
                        }
                    });

                }
            },

            getUkeyPayState( item ){
                if( item.paySuccess ==1 ){
                    return "支付完成";
                }else if(  item.paySuccess == 0  ){
                    return "Ukey待支付";
                }else if(  item.paySuccess == 2  ){
                    return "Ukey订单失败";
                }else{
                    return "";
                }

            },
            toUkeyOrder( item ){
                // 跳转至Ukey支付页面
                let _this = this;
                if( item.paySuccess ==1 ){
                    _this.$message.success('该印章Ukey已支付，可正常使用');
                    return  ;
                }else if( item.state != '1' ){
                    _this.$message.error('该印章未通过审核，请耐心等待');
                    return  ;
                }else if(   item.state == '1'  &&  item.paySuccess == 0 ){
                    item.type =  item.againStatus=='1'  ?  1   : 0
                    // item.type =  item.againStatus=='1'  ?  "追加ukey支付"   :"首次Ukey支付" 
                     _this.$router.push({
                        name: 'payUkey',
                        params:  item
                    });
                }
            },

            handlJump(item) {
                this.$router.push({
                    name: 'buyCert',
                    query: {
                        signatureId: item.id
                    }
                });

            },
            handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
            handlDele(item) {
                // delStampInfo
                let _this = this;

                _this.$confirm('此操作将永久删除该印模, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let formData = new FormData();
                    formData.append('token', _this.$global.token);
                    formData.append('id', item.id);
                    _this.api.delSignatureInfoById(formData).then(res => {
                        console.log(res);
                        if (res.code !== 0) {
                            return _this.$message.error('服务繁忙');
                        }
                        _this.$message.success('删除成功');
                        let param = new FormData();
                        param.append('token', _this.$global.token);
                        _this.getData(param);
                    })
                }).catch(() => {
                });
            },
            openUpdate(index) {
                this.updateIndex = index;
               this.dialogFormVisible =true;

            },

             handlUpdate() {
                var index = this.updateIndex;
                var item = this.sealList[index];
                let _this = this;
                this.$refs['form'][0].validate((valid) => {
                    if (valid) {
                    var para=new FormData();
                    para.append("id",item["id"]);
                    para.append("password",this.form.password);
                    para.append("newPassword",this.form.againPassword);
                    _this.api.uptSignatureInfoPwdById(para).then(res => {
                        console.log(res);
                        if (res.code !== 0) {
                            return _this.$message.error('修改失败');
                        }
                        _this.$message.success('修改成功');
                        let param = new FormData();
                        param.append('token', _this.$global.token);
                        _this.getData(param);
                        this.dialogFormVisible = false;
                    })

                        this.$refs['form'][0].resetFields();
                        
                    } else {
                        alert('请检查输入内容');
                        return false;
                    }
                });

             },

            getData(param) {
                let _this = this;
                //getMyCertList   getStampList
                _this.api.getMyCertList(param).then(res => {
                    _this.sealList = res.data;
                    console.log(res.data);
                })
            },
            handlAddSeal() {
                this.$router.push('perSeal');
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    #sealDialog /deep/ .el-dialog {
        background-color: #ffffff;
        border-radius: 30px;
        border: solid 1px #aaaaaa;
        width: 35% !important;

        .all {
            width: auto;
            height: auto;
            display: flex;
            justify-content: center;

            .perSeal {
                width: 240px;
                height: 240px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                letter-spacing: 2px;
                color: #ffffff;
                @column();

                img {
                    width: 66px;
                    height: 62px;
                    margin-bottom: 33px;
                    object-fit: cover;
                }
            }

            .entSeal {
                width: 240px;
                height: 240px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                margin-left: 40px;
                letter-spacing: 2px;
                color: #ffffff;
                cursor: pointer;
                @column();

                img {
                    width: 66px;
                    height: 62px;
                    margin-bottom: 33px;
                    object-fit: cover;
                }
            }
        }
    }

    .sealList {
        width: @a;
        height: auto;
        margin-left: 4%;

        .seal_title {
            width: 1090px;
            height: 40px;
            display: flex;
            align-items: center;

            .title {
                width: 180px;
                height: auto;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .btn {
                width: 150px;
                height: 40px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                letter-spacing: 1px;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                margin-left: 23px;
                cursor: pointer;
                font-size: 16px;
            }

            .select {
                width: 245px;
                height: 40px;
                margin-left: 550px;
            }
        }

        .seal_message {
            width: @a;
            height: auto;

            .for:nth-child(4n+1) {
                margin-left: 0;
            }

            .for {
                width: auto;
                height: auto;
                background-color: #ffffff;
                display: inline-block;
                margin-left: 35px;
                margin-top: 30px;
                position: relative;

                .ukey {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    @row();
                    border-radius: 50%;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#ffffff,
                    #ffffff);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    color: #fff;
                }

                .zheG {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 55%;
                    background: #000;
                    opacity: 0.8;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .sinType {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    top: 0px;
                    right: 0px;
                    @row();
                    border-top: 50px solid #f2f2f2;
                    border-left: 70px solid transparent;

                }

                .endDay {
                    width: 100%;
                    font-size: 18px;
                    color: #333333;
                    height: auto;
                    text-align: center;
                    margin-top: 10px;
                }

                .text {
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    color: red;

                }

                .img {
                    width: 244px;
                    height: 140px;
                    background-color: #ffffff;

                    img {
                        width: @a;
                        height: @a;
                        object-fit: contain;
                    }
                }

                .zhang-btn {
                    width: 100%;
                    height: auto;
                    display: flex;
                    justify-content: space-between;

                    .btn1 {
                        width: 33%;
                        height: 46px;
                        background-color: #f5f5f5;
                        line-height: 46px;
                        text-align: center;
                        letter-spacing: 1px;
                        color: #333333;
                        cursor: pointer;
                        border-bottom: solid 1px #aaaaaa;
                        
                        font-size: 14px;
                    }

                    .btn2 {
                        width: 33%;
                        height: 46px;
                        background-color: #f5f5f5;
                        line-height: 46px;
                        text-align: center;
                        letter-spacing: 1px;
                        color: #333333;
                        cursor: pointer;
                        border-bottom: solid 1px #aaaaaa;
                        border-left: solid 1px #aaaaaa;
                        font-size: 14px;
                    }
                    .btn4 {
                        width: 33%;
                        height: 46px;
                        background-color: #f5f5f5;
                        line-height: 46px;
                        text-align: center;
                        letter-spacing: 1px;
                        color: #333333;
                        cursor: pointer;
                        border-left: solid 1px #aaaaaa;
                        font-size: 14px;
                    }
                    .btn3 {
                      width: 50%;
                      height: 46px;
                      background-color: #f5f5f5;
                      line-height: 46px;
                      text-align: center;
                      letter-spacing: 1px;
                      color: #333333;
                      cursor: pointer;
                      border-bottom: solid 1px #aaaaaa;
                      border-right: solid 1px #aaaaaa;
                      font-size: 14px;
                    }

                        .btn4 {
                        width: 50%;
                        height: 46px;
                        background-color: #f5f5f5;
                        line-height: 46px;
                        text-align: center;
                        letter-spacing: 1px;
                        color: #333333;
                        cursor: pointer;
                        border-bottom: solid 1px #aaaaaa;
                        font-size: 14px;
                    }
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/seal/sealListZhang.vue